import { sortBy } from 'lodash';

// additional content can have conditional values, but indices are hard coded
// this allows people to continue to think about hard index values, but adjusts indices
// in the cases of items prior not being rendered
export function compactWithUpdatedIndices<T extends { index: number }>(input: Array<T | false>): T[] {
  const sortedContent = sortBy(input, 'index');
  const [compactedResult] = sortedContent.reduce<[T[], number]>(
    ([content, offset], curr) => {
      if (!curr) return [content, offset + 1];
      return [[...content, { ...curr, index: curr.index - offset }], offset];
    },
    [[], 0]
  );
  return compactedResult;
}
